import { createActionRegistry } from '@krp/client-runtime'

import { SHELL_ACTION_SOURCE } from '../app/actions'
import { aqsiModule, duplicatesModule, oneCModule, platformModule, receiptsModule, scheduleModule, syncModule } from './modules'
import { WINDOW_REGISTRY } from './windows'

/**
 * Реестр действий приложения (UI-ACTIONS): записи оболочки + реестры пакетов,
 * без ветвлений по виду ресурса (ADR-18) — каждый пакет описывает свои кнопки
 * сам, как свои окна. Пакет без реестра (`actions` не объявлены) подсказок не
 * показывает; его записи приходят его карточкой (UI-ACTIONS-2b/2c).
 * Ошибка записи (чужой префикс, неизвестное окно, «заглушка» без причины)
 * роняет сборку приложения и тест composition.
 */
export const ACTION_REGISTRY = createActionRegistry(
  [SHELL_ACTION_SOURCE, platformModule, oneCModule, aqsiModule, receiptsModule, duplicatesModule, syncModule, scheduleModule],
  WINDOW_REGISTRY.all.map((window) => window.kind),
)
